export type MessageContent = string

export const EVENT_ROLE_USER = 'user' as const
export type EventRequestUserRole = typeof EVENT_ROLE_USER

export const EVENT_ROLE_ASSISTANT = 'assistant' as const
export type EventRequestAssistantRole = typeof EVENT_ROLE_ASSISTANT

export interface MessageEvent {
  type: 'message'
  role: EventRequestUserRole | EventRequestAssistantRole
  content: MessageContent
}

export type PromptSuggestion = string

export interface PromptSuggestionEvent {
  type: 'prompt_suggestion'
  role: EventRequestAssistantRole
  prompts: PromptSuggestion[]
}

export interface ProductRecommendationDetails {
  brand?: string | null
  color?: string | null
  price?: string | null
  description?: string | null
  release_date?: string | null
  sub_title_elements?: string | null
  price_brand_new_at_retailers_outside_backmarket?: string | null
}

export interface ProductRecommendation {
  name: string
  link: string
  image: string
  type?: string
  details?: ProductRecommendationDetails | null
}

export interface ProductRecommendationEvent {
  type: 'product_recommendation'
  role: EventRequestAssistantRole
  products: ProductRecommendation[]
}

export interface NoProductRecommendationEvent {
  type: 'no_product_recommendation'
  role: EventRequestAssistantRole
  content: MessageContent
}

export interface ChatRequestBody {
  context: string
  by: 'tester' | 'user'
  resume_latest?: boolean
}

export type ChatEvent =
  | MessageEvent
  | PromptSuggestionEvent
  | ProductRecommendationEvent
  | NoProductRecommendationEvent

export interface ChatResponse {
  id: string
  events: ChatEvent[]
}

// Message is written by the user
export const MESSAGE_ROLE_USER = '20' as const
export type MessageRequestUserRole = typeof MESSAGE_ROLE_USER

// Message is based on a prompt suggestion
export const MESSAGE_ROLE_SUGGESTION = '0' as const
export type MessageRequestSuggestionRole = typeof MESSAGE_ROLE_SUGGESTION

export interface MessageRequestBody {
  content: string
  role: MessageRequestUserRole | MessageRequestSuggestionRole
}

export interface MessageResponse {
  events: ChatEvent[]
}
